import React from 'react';
import './client info.css'
import { MDBContainer,  MDBRow, MDBCol,MDBBtn,MDBIcon,MDBModal, MDBModalBody, MDBModalHeader} from "mdbreact";
import "react-image-gallery/styles/css/image-gallery.css";
import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';
import CardHeader from '@material-ui/core/CardHeader';
import CardMedia from '@material-ui/core/CardMedia';
import allStrings from "../../assets/strings";
import { connect } from "react-redux";
import { withRouter,Redirect } from "react-router-dom";
import { BASE_END_POINT } from "../../urls";
import axios from "axios";
import { hasValue } from "../../validations/validations";
import { message,TreeSelect} from "antd";
import moment from 'moment';
const { TreeNode } = TreeSelect;
const { SHOW_PARENT } = TreeSelect;
class clientInfo extends React.Component {
    state = {
      actionType:this.props.location.state.actionType?this.props.location.state.actionType==="EDIT"?"EDIT":"VIEW":"VIEW",
      page:1,
      pages:1,
      id:this.props.location.state.data.id,
      clientName:this.props.location.state.data.clientName?this.props.location.state.data.clientName:'',
      clientPhone:this.props.location.state.data.clientPhone?this.props.location.state.data.clientPhone:'',
      clientCountry:this.props.location.state.data.clientCountry?this.props.location.state.data.clientCountry.id:null,
      salesMan:this.props.location.state.data.salesMan,
      createdAt:this.props.location.state.data.createdAt,
      informClient:this.props.location.state.data.informClient,
      status:this.props.location.state.data.status,
      priceFrom:this.props.location.state.data.priceFrom,
      priceTo:this.props.location.state.data.priceTo,
      category:[],
      location:[],
      user:this.props.location.state.data.user,
      notes:this.props.location.state.data.notes?this.props.location.state.data.notes:"",
      locations:[],
      categories:[],
      dealCost:this.props.location.state.data.dealCost,
      modal:false,
      modal2:false,
      reason:'',
      };

    constructor(props){
        super(props)
        window.scrollTo(0,0)
        if(this.props.isRTL){
            allStrings.setLanguage('ar')
        }else{
            allStrings.setLanguage('en')
        } 
    }

    componentDidMount(){
      this.getCategory()
      this.getLocations()
      this.getClientData()
        if(this.props.isRTL){
            allStrings.setLanguage('ar')
        }else{
            allStrings.setLanguage('en')
        } 
    }
    getClientData = () => {
      axios.get(`${BASE_END_POINT}clients/${this.state.id}`,{
        headers: {
        'Content-Type': 'application/json',
        'Authorization':`Bearer ${this.props.currentUser.token}`,
        'Accept-Language':this.props.isRTL?'ar':'en',
        }})
      .then(response=>{
          console.log('client  ',response.data.data)
          this.setState({
            loading:false,
            clientName:response.data.data.clientName,
            clientPhone:response.data.data.clientPhone,
            salesMan:response.data.data.salesMan,
            createdAt:response.data.data.createdAt,
            user:response.data.data.user,
            notes:response.data.data.notes?response.data.data.notes:"",
            informClient:response.data.data.informClient,
            status:response.data.data.status,
            dealCost:response.data.data.dealCost,
            inContactDate:response.data.data.inContactDate,
            inContactBy:response.data.data.inContactBy,
            rejectedDate:response.data.data.rejectedDate,
            rejectedBy:response.data.data.rejectedBy,
            saleDoneDate:response.data.data.saleDoneDate,
            saleDoneBy:response.data.data.saleDoneBy,
            disqualifiedDate:response.data.data.disqualifiedDate,
            disqualifiedBy:response.data.data.disqualifiedBy,
            reason:response.data.data.reason,
            priceFrom:response.data.data.priceFrom,
            priceTo:response.data.data.priceTo,
            
          })
          if(response.data.data.category){
            let category = []
            response.data.data.category.forEach(v => {
              category.push(v.id)
            });
            this.setState({category:category})
          }
          if(response.data.data.location){
            let location = []
            response.data.data.location.forEach(v => {
              location.push(v.id)
            });
            this.setState({location:location})
          }
      })
      .catch(error=>{
          console.log('theClient ERROR  ',error)
          console.log('theClient ERROR  ',error.respose)
      })
    }
    getCategory = () => {
      axios.get(`${BASE_END_POINT}categories`)
      .then(response=>{
        console.log(response.data)
        this.setState({categories:response.data.data})
      })
      .catch(error=>{
        console.log("ALL categories ERROR")
        console.log(error.response)
      })
    }
    getLocations = () => {
      axios.get(`${BASE_END_POINT}location/withoutPagenation/get`)
      .then(response=>{
        console.log(response.data)
        this.setState({locations:response.data.data})
      })
      .catch(error=>{
        console.log("ALL locations ERROR")
        console.log(error.response)
      })
    }
    update = () => {
        const {clientName,clientPhone,informClient,category,location} = this.state
        if(hasValue(clientName)&&hasValue(clientPhone)){
          let l = message.loading('Wait..', 2.5)
          const data={
              'clientName':clientName,
              'clientPhone':clientPhone,
              'informClient':informClient,
              'category':category,
              'location':location
          }
          axios.put(`${BASE_END_POINT}clients/${this.props.location.state.data.id}`,JSON.stringify(data),{
          headers: {
          'Content-Type': 'application/json',
          'Authorization':`Bearer ${this.props.currentUser.token}`,
          'Accept-Language':this.props.isRTL?'ar':'en',
          },
          })
          .then(response=>{
          console.log("client UPDATED  ",response.data)
          l.then(() => message.success(allStrings.done, 2.5) )
          this.props.history.goBack() 
          })
          .catch(error=>{
              console.log(error.response)
              if(error.response.data.errors.msg[0].msg){
                  l.then(() => message.error(error.response.data.errors.msg[0].msg, 2.5))

              }else{
                  l.then(() => message.error(allStrings.error, 2.5))

              }
          })
        }
    }

    delete = () => {
        let l = message.loading('Wait..', 2.5)
        axios.delete(`${BASE_END_POINT}clients/${this.props.location.state.data.id}`,{
         headers: {
           'Content-Type': 'application/json',
           'Authorization':`Bearer ${this.props.currentUser.token}`,
           'Accept-Language':this.props.isRTL?'ar':'en',
         },
        })
        .then(response=>{
          console.log("client DELETED")
          l.then(() => message.success(allStrings.done, 2.5) )
          this.props.history.goBack() 
        })
        .catch(error=>{
            console.log(error.response)
            l.then(() => message.error(allStrings.error, 2.5))
        })
    }
    inContact = () => {
        let l = message.loading('Wait..', 2.5)
        axios.put(`${BASE_END_POINT}clients/${this.props.location.state.data.id}/inContact`,{},{
        headers: {
          'Content-Type': 'application/json',
          'Authorization':`Bearer ${this.props.currentUser.token}`,
          'Accept-Language':this.props.isRTL?'ar':'en',
        },
        })
        .then(response=>{
          console.log("client inContact")
          l.then(() => message.success(allStrings.done, 2.5) )
          this.props.history.goBack() 
        })
        .catch(error=>{
            console.log(error.response)
            l.then(() => message.error(allStrings.error, 2.5))
        })
    }
    reject = () => {
        let l = message.loading('Wait..', 2.5)
        axios.put(`${BASE_END_POINT}clients/${this.props.location.state.data.id}/reject`,{reason:this.state.reason},{
        headers: {
          'Content-Type': 'application/json',
          'Authorization':`Bearer ${this.props.currentUser.token}`,
          'Accept-Language':this.props.isRTL?'ar':'en',
        },
        })
        .then(response=>{
          console.log("client reject")
          l.then(() => message.success(allStrings.done, 2.5) )
          this.props.history.goBack() 
        })
        .catch(error=>{
            console.log(error.response)
            l.then(() => message.error(allStrings.error, 2.5))
        })
    }

    saleDone = () => {
      let l = message.loading('Wait..', 2.5)
      axios.put(`${BASE_END_POINT}clients/${this.props.location.state.data.id}/saleDone`,{dealCost:this.state.dealCost},{
      headers: {
        'Content-Type': 'application/json',
        'Authorization':`Bearer ${this.props.currentUser.token}`,
        'Accept-Language':this.props.isRTL?'ar':'en',
      },
      })
      .then(response=>{
        console.log("client saleDone")
        l.then(() => message.success(allStrings.done, 2.5) )
        this.props.history.goBack() 
      })
      .catch(error=>{
          console.log(error.response)
          l.then(() => message.error(allStrings.error, 2.5))
      })
    }
    disqualified = () => {
      let l = message.loading('Wait..', 2.5)
      axios.put(`${BASE_END_POINT}clients/${this.props.location.state.data.id}/disqualified`,{dealCost:this.state.dealCost},{
      headers: {
        'Content-Type': 'application/json',
        'Authorization':`Bearer ${this.props.currentUser.token}`,
        'Accept-Language':this.props.isRTL?'ar':'en',
      },
      })
      .then(response=>{
        console.log("client disqualified")
        l.then(() => message.success(allStrings.done, 2.5) )
        this.props.history.goBack() 
      })
      .catch(error=>{
          console.log(error.response)
          l.then(() => message.error(allStrings.error, 2.5))
      })
    }
    submitHandler = event => {
        event.preventDefault();
        console.log(event.target.className)
        event.target.className += " was-validated";
        this.update()
    };

    changeHandler = event => {
        this.setState({ [event.target.name]: event.target.value });
    };
    changeHandlerSaleDone = event => {
      this.setState({ [event.target.name]: event.target.value });
    };
    submitHandlerSaleDone = event => {
      event.preventDefault();
      console.log(event.target.className)
      event.target.className += " was-validated";
      this.saleDone()
    };
    modal = () =>(
      <MDBModal isOpen={this.state.modal} toggle={this.toggle} size="lg">
        <MDBModalHeader toggle={this.toggle} >{allStrings.completeData}</MDBModalHeader>
          <MDBModalBody>
            <MDBContainer>
              <MDBRow>
                <MDBCol md="12">
                  <form style={{paddingTop:'1rem'}}
                    className="needs-validation"
                    onSubmit={this.submitHandlerSaleDone}
                    noValidate
                  >
                    <div className="grey-text">
                      <MDBRow>
                        <MDBCol md="12">
                          <div className="md-form">
                            <label htmlFor="form92" style={{textAlign:this.props.isRTL?'right':'left',width:'100%'}}>{allStrings.dealCost}</label>
                            <input  style={{direction:this.props.isRTL?'rtl':'ltr',backgroundPosition: this.props.isRTL?'left calc(.375em + .1875rem) center':'right calc(.375em + .1875rem) center'}} type="number" min={0} id="form92" className="form-control" onChange={this.changeHandlerSaleDone} required validate  name="dealCost" defaultValue={this.state.dealCost}/>
                          </div>
                        </MDBCol>
                      </MDBRow>
                    
                    </div>
                    <br></br>
                    <br></br>
                    <div className="text-center">
                      <MDBBtn type="submit" style={{ background: '#233b5b' }} rounded className="btn-block z-depth-1a" >
                        {allStrings.done}
                      </MDBBtn>
                    </div>
                  </form>
                </MDBCol>
              </MDBRow>
            </MDBContainer>
        </MDBModalBody>
      </MDBModal>
    );
    toggle = () => {
      this.setState({
          modal: !this.state.modal,
      });
    }
    submitHandlerDisqualified = event => {
      event.preventDefault();
      console.log(event.target.className)
      event.target.className += " was-validated";
      if(this.state.closeType =="REJECTED"){
        this.reject()
      }else{
        this.disqualified()
      }
    };
    modal2 = () =>(
      <MDBModal isOpen={this.state.modal2} toggle={this.toggle2} size="lg">
        <MDBModalHeader toggle={this.toggle2} >{allStrings.completeData}</MDBModalHeader>
          <MDBModalBody>
            <MDBContainer>
              <MDBRow>
                <MDBCol md="12">
                  <form style={{paddingTop:'1rem'}}
                    className="needs-validation"
                    onSubmit={this.submitHandlerDisqualified}
                    noValidate
                  >
                    <div className="grey-text">
                      <MDBRow>
                        <MDBCol md="12">
                            <div class="md-form">
                            <label for="form9220" style={{textAlign:this.props.isRTL?'right':'left',width:'100%'}}>{allStrings.reason}</label>
                            <br></br>
                            <textarea style={{direction:this.props.isRTL?'rtl':'ltr',backgroundPosition: this.props.isRTL?'left calc(.375em + .1875rem) center':'right calc(.375em + .1875rem) center',padding:'.3rem 7px .4rem 0'}} type="text" id="form9220" class="form-control"  onChange={this.changeHandler} required validate  name="reason"/>
                            </div>
                        </MDBCol>
                      </MDBRow>
                    
                    </div>
                    <br></br>
                    <br></br>
                    <div className="text-center">
                      <MDBBtn type="submit" style={{ background: '#233b5b' }} rounded className="btn-block z-depth-1a" >
                        {allStrings.done}
                      </MDBBtn>
                    </div>
                  </form>
                </MDBCol>
              </MDBRow>
            </MDBContainer>
        </MDBModalBody>
      </MDBModal>
    );
    toggle2 = () => {
      this.setState({
          modal2: !this.state.modal2,
      });
    }
  render(){
    if (this.props.currentUser.user.type === "SUB-ADMIN" && !this.props.currentUser.user.permission.pages.includes('CLIENTS')) return <Redirect to='/Home' />
  return (
    <div className="App">
        <MDBContainer> 
        {this.modal()}
        {this.modal2()}
            <MDBRow>  
                <MDBCol md="12">
                    <div className="infoCard">
                        <Card className="editCard">
                        <CardMedia
                        style={{height:"0px"}}
                        />
                        <CardHeader></CardHeader>
                        <div style={{flexDirection: this.props.isRTL?'row-reverse':'row',display: 'flex'}}>
                            <div className="topIcon">
                                <span className="material-icons" style={{color:'white',fontSize:23}}>contact_phone</span>
                            </div>
                            <div className="tableTitle" style={{display:this.props.isRTL?'inline-block':'inline-block',marginTop:this.props.isRTL?'-60px':'-60px',
                            marginLeft:this.props.isRTL?'0':'7.5rem',marginRight:this.props.isRTL?'8.5rem':'0'}}>
                            <p>{this.state.actionType==="VIEW"?allStrings.info:allStrings.edit}</p>
                            </div>
                        </div>
                        <CardContent style={{minHeight:"390px",outline:'none'}}>
                        <MDBContainer>
                            
                            <MDBRow>
                                <MDBCol md="12">
                                <form
                                className="needs-validation"
                                onSubmit={this.submitHandler}
                                noValidate
                                >
                                    <div className="grey-text">
                                   {this.state.actionType==="VIEW"&&
                                    <MDBRow>
                                        <MDBCol md="6">
                                            <div className="md-form">
                                            <label htmlFor="form6015" style={{textAlign:this.props.isRTL?'right':'left',width:'100%'}}>#</label>
                                            <input disabled  style={{direction:this.props.isRTL?'rtl':'ltr',backgroundPosition: this.props.isRTL?'left calc(.375em + .1875rem) center':'right calc(.375em + .1875rem) center'}} value={this.state.id} type="text" id="form6015"  className="form-control" />
                                            <div class="valid-feedback">{allStrings.correct}</div>
                                            <div class="invalid-feedback">{allStrings.requiredInput}</div>
                                            </div>
                                        </MDBCol>
                                        <MDBCol md="6">
                                            <div className="md-form">
                                            <label htmlFor="form6025" style={{textAlign:this.props.isRTL?'right':'left',width:'100%'}}>{allStrings.informClient}</label>
                                            <input disabled  style={{direction:this.props.isRTL?'rtl':'ltr',backgroundPosition: this.props.isRTL?'left calc(.375em + .1875rem) center':'right calc(.375em + .1875rem) center'}} value={this.state.informClient?allStrings.yes:allStrings.no} type="text" id="form6025"  className="form-control" />
                                            <div class="valid-feedback">{allStrings.correct}</div>
                                            <div class="invalid-feedback">{allStrings.requiredInput}</div>
                                            </div>
                                        </MDBCol>
                                        
                                    </MDBRow>
                                    }
                                    {this.state.actionType==="VIEW"&&
                                    <MDBRow>
                                        <MDBCol md={this.state.status==="SALE-DONE"?"6":"12"}>
                                            <div className="md-form">
                                            <label htmlFor="form6005" style={{textAlign:this.props.isRTL?'right':'left',width:'100%'}}>{allStrings.status}</label>
                                            <input disabled  style={{direction:this.props.isRTL?'rtl':'ltr',backgroundPosition: this.props.isRTL?'left calc(.375em + .1875rem) center':'right calc(.375em + .1875rem) center'}} value={this.state.status === "PENDING"?allStrings.pending:this.state.status === "IN-CONTACT"?allStrings.inContact:this.state.status==="REJECTED"?allStrings.rejected:this.state.status ==="SALE-DONE"?allStrings.saleDone:allStrings.disqualified} type="text" id="form6005"  className="form-control" />
                                            <div class="valid-feedback">{allStrings.correct}</div>
                                            <div class="invalid-feedback">{allStrings.requiredInput}</div>
                                            </div>
                                        </MDBCol>
                                        {this.state.status==="SALE-DONE"&&
                                        <MDBCol md="6">
                                            <div className="md-form">
                                            <label htmlFor="form605" style={{textAlign:this.props.isRTL?'right':'left',width:'100%'}}>{allStrings.dealCost}</label>
                                            <input disabled  style={{direction:this.props.isRTL?'rtl':'ltr',backgroundPosition: this.props.isRTL?'left calc(.375em + .1875rem) center':'right calc(.375em + .1875rem) center'}} value={this.state.dealCost} type="text" id="form605"  className="form-control" />
                                            <div class="valid-feedback">{allStrings.correct}</div>
                                            <div class="invalid-feedback">{allStrings.requiredInput}</div>
                                            </div>
                                        </MDBCol>
                                        }
                                        
                                    </MDBRow>
                                    }
                                    
                                    <MDBRow>
                                        <MDBCol md="6">
                                            <div className="md-form">
                                            <label htmlFor="form65" style={{textAlign:this.props.isRTL?'right':'left',width:'100%'}}>{allStrings.clientName}</label>
                                            <input disabled style={{direction:this.props.isRTL?'rtl':'ltr',backgroundPosition: this.props.isRTL?'left calc(.375em + .1875rem) center':'right calc(.375em + .1875rem) center'}} value={this.state.clientName} type="text" id="form645" name="clientName" className="form-control" onChange={this.changeHandler} required  validate/>
                                            <div class="valid-feedback">{allStrings.correct}</div>
                                            <div class="invalid-feedback">{allStrings.requiredInput}</div>
                                            </div>
                                        </MDBCol>
                                        <MDBCol md="6">
                                            <div className="md-form">
                                            <label htmlFor="form56" style={{textAlign:this.props.isRTL?'right':'left',width:'100%'}}>{allStrings.clientPhone}</label>
                                            <input disabled onInput={(e) =>e.currentTarget.value = e.currentTarget.value.replace(/[^0-9+]/g,'') } style={{direction:this.props.isRTL?'rtl':'ltr',backgroundPosition: this.props.isRTL?'left calc(.375em + .1875rem) center':'right calc(.375em + .1875rem) center'}} value={this.state.clientPhone} type="text" id="form56" name="clientPhone" className="form-control" onChange={this.changeHandler} required validate/>
                                            <div class="valid-feedback">{allStrings.correct}</div>
                                            <div class="invalid-feedback">{allStrings.requiredInput}</div>
                                            </div>
                                        </MDBCol>
                                    </MDBRow>
                                    <MDBRow>
                                        <MDBCol md="6">
                                            <div className="md-form">
                                            <label htmlFor="form65" style={{textAlign:this.props.isRTL?'right':'left',width:'100%'}}>{allStrings.priceFrom}</label>
                                            <input disabled style={{direction:this.props.isRTL?'rtl':'ltr',backgroundPosition: this.props.isRTL?'left calc(.375em + .1875rem) center':'right calc(.375em + .1875rem) center'}} value={this.state.priceFrom} type="text" id="form645" name="priceFrom" className="form-control" onChange={this.changeHandler} required  validate/>
                                            <div class="valid-feedback">{allStrings.correct}</div>
                                            <div class="invalid-feedback">{allStrings.requiredInput}</div>
                                            </div>
                                        </MDBCol>
                                        <MDBCol md="6">
                                            <div className="md-form">
                                            <label htmlFor="form56" style={{textAlign:this.props.isRTL?'right':'left',width:'100%'}}>{allStrings.priceTo}</label>
                                            <input disabled style={{direction:this.props.isRTL?'rtl':'ltr',backgroundPosition: this.props.isRTL?'left calc(.375em + .1875rem) center':'right calc(.375em + .1875rem) center'}} value={this.state.priceTo} type="text" id="form56" name="priceTo" className="form-control" onChange={this.changeHandler} required validate/>
                                            <div class="valid-feedback">{allStrings.correct}</div>
                                            <div class="invalid-feedback">{allStrings.requiredInput}</div>
                                            </div>
                                        </MDBCol>
                                    </MDBRow>
                                    <MDBRow>
                                      <MDBCol md="6" sm="6">
                                          <label style={{textAlign:this.props.isRTL?'right':'left',width:'100%'}}>{allStrings.location}</label>
                                          <TreeSelect virtual={false}
                                              showSearch={true}
                                              style={{ width: '100%' ,textAlign:this.props.isRTL?'right':'left',height:'35px',marginBottom:'1rem'}} 
                                              treeCheckable = {true}
                                              treeNodeFilterProp="title"   
                                              disabled={this.state.actionType==="EDIT"?false:true}                   
                                              dropdownStyle={{ maxHeight: 400, overflow: 'auto' }}
                                              placeholder={allStrings.location}
                                              value={this.state.location}
                                              showCheckedStrategy= {SHOW_PARENT}
                                              onChange={(value) => {
                                              console.log(value)
                                              this.setState({location:value});
                                              }} 
                                          
                                          >
                                              {this.state.locations.map(val=>(
                                                  <TreeNode value={val.id} title={this.props.isRTL?val.name_ar:val.name_en} key={val.id} />
                                              ))}
                                          </TreeSelect>
                                      </MDBCol>
                                      <MDBCol md="6" sm="6">
                                          <label style={{textAlign:this.props.isRTL?'right':'left',width:'100%'}}>{allStrings.category}</label>
                                          <TreeSelect virtual={false}
                                              showSearch={false}
                                              disabled={this.state.actionType==="EDIT"?false:true} 
                                              style={{ width: '100%' ,textAlign:this.props.isRTL?'right':'left',height:'35px',marginBottom:'1rem'}} 
                                              treeCheckable = {true}         
                                              treeNodeFilterProp="title"                      
                                              dropdownStyle={{ maxHeight: 400, overflow: 'auto' }}
                                              placeholder={allStrings.category}
                                              value={this.state.category}
                                              showCheckedStrategy= {SHOW_PARENT}
                                              onChange={(value) => {
                                                console.log(value)
                                                this.setState({category:value});
                                              }} 
                                          
                                          >
                                              {this.state.categories.map(val=>(
                                                  <TreeNode value={val.id} title={this.props.isRTL?val.name_ar:val.name_en} key={val.id} />
                                              ))}
                                          </TreeSelect>
                                      </MDBCol>
                                    
                                    </MDBRow>
                                    <MDBRow>
                                        <MDBCol md="12">
                                            <div class="md-form">
                                            <label for="form9220" style={{textAlign:this.props.isRTL?'right':'left',width:'100%'}}>{allStrings.notes}</label>
                                            <br></br>
                                            <textarea disabled={this.state.actionType==="EDIT"?false:true}  value={this.state.notes} style={{direction:this.props.isRTL?'rtl':'ltr',backgroundPosition: this.props.isRTL?'left calc(.375em + .1875rem) center':'right calc(.375em + .1875rem) center',padding:'.3rem 7px .4rem 0'}} type="text" id="form9220" class="form-control"  validate  name="notes"/>
                                            </div>
                                        </MDBCol>
                                    </MDBRow>
                                    {this.state.actionType==="VIEW"&& this.state.createdAt&&
                                    <MDBRow>
                                        <MDBCol md="12">
                                            <div className="md-form">
                                            <label htmlFor="form062" style={{textAlign:this.props.isRTL?'right':'left',width:'100%'}}>{allStrings.date}</label>
                                            <input disabled  style={{direction:this.props.isRTL?'rtl':'ltr',backgroundPosition: this.props.isRTL?'left calc(.375em + .1875rem) center':'right calc(.375em + .1875rem) center'}} defaultValue={moment(this.state.createdAt).format('lll')} type="text"  id="form062"  className="form-control"  validate/>
                                            <div class="valid-feedback">{allStrings.correct}</div>
                                            <div class="invalid-feedback">{allStrings.requiredInput}</div>
                                            </div>
                                        </MDBCol>
                                        
                                    </MDBRow>
                                    }
                                    {this.state.actionType==="VIEW"&&
                                      <MDBRow style={{flexDirection:this.props.isRTL?'row-reverse':'row'}}>
                                          <MDBCol md="10" xs="10">
                                              <div class="md-form">
                                              <label for="form80" style={{textAlign:this.props.isRTL?'right':'left',width:'100%'}}>{allStrings.addedBy}</label>
                                              <input disabled  style={{direction:this.props.isRTL?'rtl':'ltr',backgroundPosition: this.props.isRTL?'left calc(.375em + .1875rem) center':'right calc(.375em + .1875rem) center'}} value={this.state.user?this.state.user.fullname:''} type="text" id="form80" class="form-control"  />
                                              </div>
                                          </MDBCol>
                                          <MDBCol md="2" xs="2">
                                        
                                          <p style={{textAlign: 'center',marginTop: '2rem',color: '#2BBBAD'}}>
                                              <span style={{cursor:'pointer',position: 'absolute',padding: '3px'}} class="material-icons"
                                              onClick={()=>{this.props.history.push('userInfo',{data:this.state.user,actionType:'VIEW'}) }}>
                                                remove_red_eye
                                              </span>
                                              <span style={{cursor:'pointer',fontSize: '16px',fontWeight: '500',marginLeft: '2rem'}}
                                                onClick={()=>{this.props.history.push('userInfo',{data:this.state.user}) }}>
                                                {allStrings.show}
                                              </span> 
                                            </p>
                                          </MDBCol>
                                      </MDBRow>
                                    }
                                    {this.state.actionType ==="VIEW" && this.state.salesMan&&
                                      <MDBRow style={{flexDirection:this.props.isRTL?'row-reverse':'row'}}>
                                          <MDBCol md="10" xs="10">
                                              <div class="md-form">
                                              <label for="form80" style={{textAlign:this.props.isRTL?'right':'left',width:'100%'}}>{allStrings.salesMan}</label>
                                              <input disabled  style={{direction:this.props.isRTL?'rtl':'ltr',backgroundPosition: this.props.isRTL?'left calc(.375em + .1875rem) center':'right calc(.375em + .1875rem) center'}} value={this.state.salesMan?this.state.salesMan.fullname:''} type="text" id="form80" class="form-control"  />
                                              </div>
                                          </MDBCol>
                                          <MDBCol md="2" xs="2">
                                        
                                          <p style={{textAlign: 'center',marginTop: '2rem',color: '#2BBBAD'}}>
                                              <span style={{cursor:'pointer',position: 'absolute',padding: '3px'}} class="material-icons"
                                              onClick={()=>{this.props.history.push('userInfo',{data:this.state.salesMan,actionType:'VIEW'}) }}>
                                                remove_red_eye
                                              </span>
                                              <span style={{cursor:'pointer',fontSize: '16px',fontWeight: '500',marginLeft: '2rem'}}
                                                onClick={()=>{this.props.history.push('userInfo',{data:this.state.salesMan}) }}>
                                                {allStrings.show}
                                              </span> 
                                            </p>
                                          </MDBCol>
                                      </MDBRow>
                                    }
                                    {this.state.reason&&
                                    <MDBRow>
                                        <MDBCol md="12">
                                            <div class="md-form">
                                            <label for="form9220" style={{textAlign:this.props.isRTL?'right':'left',width:'100%'}}>{allStrings.reason}</label>
                                            <br></br>
                                            <textarea disabled={this.state.actionType==="EDIT"?false:true}  value={this.state.reason} style={{direction:this.props.isRTL?'rtl':'ltr',backgroundPosition: this.props.isRTL?'left calc(.375em + .1875rem) center':'right calc(.375em + .1875rem) center',padding:'.3rem 7px .4rem 0'}} type="text" id="form9220" class="form-control"  validate  name="reason"/>
                                            </div>
                                        </MDBCol>
                                    </MDBRow>
                                    }
                                    {this.state.actionType==="VIEW"&& this.state.inContactDate&&
                                    <MDBRow>
                                        <MDBCol md="12">
                                            <div className="md-form">
                                            <label htmlFor="form062" style={{textAlign:this.props.isRTL?'right':'left',width:'100%'}}>{allStrings.inContactDate}</label>
                                            <input disabled  style={{direction:this.props.isRTL?'rtl':'ltr',backgroundPosition: this.props.isRTL?'left calc(.375em + .1875rem) center':'right calc(.375em + .1875rem) center'}} defaultValue={moment(this.state.createdAt).format('lll')} type="text"  id="form062"  className="form-control"  validate/>
                                            <div class="valid-feedback">{allStrings.correct}</div>
                                            <div class="invalid-feedback">{allStrings.requiredInput}</div>
                                            </div>
                                        </MDBCol>
                                        
                                    </MDBRow>
                                    }
                                    {this.state.actionType==="VIEW"&& this.state.inContactBy &&
                                      <MDBRow style={{flexDirection:this.props.isRTL?'row-reverse':'row'}}>
                                          <MDBCol md="10" xs="10">
                                              <div class="md-form">
                                              <label for="form80" style={{textAlign:this.props.isRTL?'right':'left',width:'100%'}}>{allStrings.inContactBy}</label>
                                              <input disabled  style={{direction:this.props.isRTL?'rtl':'ltr',backgroundPosition: this.props.isRTL?'left calc(.375em + .1875rem) center':'right calc(.375em + .1875rem) center'}} value={this.state.inContactBy?this.state.inContactBy.fullname:''} type="text" id="form80" class="form-control"  />
                                              </div>
                                          </MDBCol>
                                          <MDBCol md="2" xs="2">
                                        
                                          <p style={{textAlign: 'center',marginTop: '2rem',color: '#2BBBAD'}}>
                                              <span style={{cursor:'pointer',position: 'absolute',padding: '3px'}} class="material-icons"
                                              onClick={()=>{this.props.history.push('userInfo',{data:this.state.inContactBy,actionType:'VIEW'}) }}>
                                                remove_red_eye
                                              </span>
                                              <span style={{cursor:'pointer',fontSize: '16px',fontWeight: '500',marginLeft: '2rem'}}
                                                onClick={()=>{this.props.history.push('userInfo',{data:this.state.inContactdBy}) }}>
                                                {allStrings.show}
                                              </span> 
                                            </p>
                                          </MDBCol>
                                      </MDBRow>
                                    }
                                    {this.state.actionType==="VIEW"&& this.state.rejectedDate&&
                                    <MDBRow>
                                        <MDBCol md="12">
                                            <div className="md-form">
                                            <label htmlFor="form062" style={{textAlign:this.props.isRTL?'right':'left',width:'100%'}}>{allStrings.rejectedDate}</label>
                                            <input disabled  style={{direction:this.props.isRTL?'rtl':'ltr',backgroundPosition: this.props.isRTL?'left calc(.375em + .1875rem) center':'right calc(.375em + .1875rem) center'}} defaultValue={moment(this.state.createdAt).format('lll')} type="text"  id="form062"  className="form-control"  validate/>
                                            <div class="valid-feedback">{allStrings.correct}</div>
                                            <div class="invalid-feedback">{allStrings.requiredInput}</div>
                                            </div>
                                        </MDBCol>
                                        
                                    </MDBRow>
                                    }
                                    {this.state.actionType==="VIEW"&& this.state.rejectedBy &&
                                      <MDBRow style={{flexDirection:this.props.isRTL?'row-reverse':'row'}}>
                                          <MDBCol md="10" xs="10">
                                              <div class="md-form">
                                              <label for="form80" style={{textAlign:this.props.isRTL?'right':'left',width:'100%'}}>{allStrings.rejectedBy}</label>
                                              <input disabled  style={{direction:this.props.isRTL?'rtl':'ltr',backgroundPosition: this.props.isRTL?'left calc(.375em + .1875rem) center':'right calc(.375em + .1875rem) center'}} value={this.state.rejectedBy?this.state.rejectedBy.fullname:''} type="text" id="form80" class="form-control"  />
                                              </div>
                                          </MDBCol>
                                          <MDBCol md="2" xs="2">
                                        
                                          <p style={{textAlign: 'center',marginTop: '2rem',color: '#2BBBAD'}}>
                                              <span style={{cursor:'pointer',position: 'absolute',padding: '3px'}} class="material-icons"
                                              onClick={()=>{this.props.history.push('userInfo',{data:this.state.rejectedBy,actionType:'VIEW'}) }}>
                                                remove_red_eye
                                              </span>
                                              <span style={{cursor:'pointer',fontSize: '16px',fontWeight: '500',marginLeft: '2rem'}}
                                                onClick={()=>{this.props.history.push('userInfo',{data:this.state.rejectedBy}) }}>
                                                {allStrings.show}
                                              </span> 
                                            </p>
                                          </MDBCol>
                                      </MDBRow>
                                    }
                                    {this.state.actionType==="VIEW"&&
                                    <MDBRow>
                                        <MDBCol md="12">
                                            <div className="md-form">
                                            <label htmlFor="form062" style={{textAlign:this.props.isRTL?'right':'left',width:'100%'}}>{allStrings.date}</label>
                                            <input disabled  style={{direction:this.props.isRTL?'rtl':'ltr',backgroundPosition: this.props.isRTL?'left calc(.375em + .1875rem) center':'right calc(.375em + .1875rem) center'}} defaultValue={moment(this.state.createdAt).format('lll')} type="text"  id="form062"  className="form-control"  validate/>
                                            <div class="valid-feedback">{allStrings.correct}</div>
                                            <div class="invalid-feedback">{allStrings.requiredInput}</div>
                                            </div>
                                        </MDBCol>
                                        
                                    </MDBRow>
                                    }
                                    {this.state.actionType==="VIEW"&& this.state.saleDoneDate&&
                                    <MDBRow>
                                        <MDBCol md="12">
                                            <div className="md-form">
                                            <label htmlFor="form062" style={{textAlign:this.props.isRTL?'right':'left',width:'100%'}}>{allStrings.saleDoneDate}</label>
                                            <input disabled  style={{direction:this.props.isRTL?'rtl':'ltr',backgroundPosition: this.props.isRTL?'left calc(.375em + .1875rem) center':'right calc(.375em + .1875rem) center'}} defaultValue={moment(this.state.saleDoneDate).format('lll')} type="text"  id="form062"  className="form-control"  validate/>
                                            <div class="valid-feedback">{allStrings.correct}</div>
                                            <div class="invalid-feedback">{allStrings.requiredInput}</div>
                                            </div>
                                        </MDBCol>
                                        
                                    </MDBRow>
                                    }
                                    {this.state.actionType==="VIEW"&& this.state.saleDoneBy &&
                                      <MDBRow style={{flexDirection:this.props.isRTL?'row-reverse':'row'}}>
                                          <MDBCol md="10" xs="10">
                                              <div class="md-form">
                                              <label for="form80" style={{textAlign:this.props.isRTL?'right':'left',width:'100%'}}>{allStrings.saleDoneBy}</label>
                                              <input disabled  style={{direction:this.props.isRTL?'rtl':'ltr',backgroundPosition: this.props.isRTL?'left calc(.375em + .1875rem) center':'right calc(.375em + .1875rem) center'}} value={this.state.saleDoneBy?this.state.saleDoneBy.fullname:''} type="text" id="form80" class="form-control"  />
                                              </div>
                                          </MDBCol>
                                          <MDBCol md="2" xs="2">
                                        
                                          <p style={{textAlign: 'center',marginTop: '2rem',color: '#2BBBAD'}}>
                                              <span style={{cursor:'pointer',position: 'absolute',padding: '3px'}} class="material-icons"
                                              onClick={()=>{this.props.history.push('userInfo',{data:this.state.saleDoneBy,actionType:'VIEW'}) }}>
                                                remove_red_eye
                                              </span>
                                              <span style={{cursor:'pointer',fontSize: '16px',fontWeight: '500',marginLeft: '2rem'}}
                                                onClick={()=>{this.props.history.push('userInfo',{data:this.state.saleDoneBy}) }}>
                                                {allStrings.show}
                                              </span> 
                                            </p>
                                          </MDBCol>
                                      </MDBRow>
                                    }
                                    {this.state.actionType==="VIEW"&& this.state.disqualifiedDate&&
                                    <MDBRow>
                                        <MDBCol md="12">
                                            <div className="md-form">
                                            <label htmlFor="form062" style={{textAlign:this.props.isRTL?'right':'left',width:'100%'}}>{allStrings.disqualifiedDate}</label>
                                            <input disabled  style={{direction:this.props.isRTL?'rtl':'ltr',backgroundPosition: this.props.isRTL?'left calc(.375em + .1875rem) center':'right calc(.375em + .1875rem) center'}} defaultValue={moment(this.state.disqualifiedDate).format('lll')} type="text"  id="form062"  className="form-control"  validate/>
                                            <div class="valid-feedback">{allStrings.correct}</div>
                                            <div class="invalid-feedback">{allStrings.requiredInput}</div>
                                            </div>
                                        </MDBCol>
                                        
                                    </MDBRow>
                                    }
                                    {this.state.actionType==="VIEW"&& this.state.disqualifiedBy &&
                                      <MDBRow style={{flexDirection:this.props.isRTL?'row-reverse':'row'}}>
                                          <MDBCol md="10" xs="10">
                                              <div class="md-form">
                                              <label for="form80" style={{textAlign:this.props.isRTL?'right':'left',width:'100%'}}>{allStrings.disqualifiedBy}</label>
                                              <input disabled  style={{direction:this.props.isRTL?'rtl':'ltr',backgroundPosition: this.props.isRTL?'left calc(.375em + .1875rem) center':'right calc(.375em + .1875rem) center'}} value={this.state.disqualifiedBy?this.state.disqualifiedBy.fullname:''} type="text" id="form80" class="form-control"  />
                                              </div>
                                          </MDBCol>
                                          <MDBCol md="2" xs="2">
                                        
                                          <p style={{textAlign: 'center',marginTop: '2rem',color: '#2BBBAD'}}>
                                              <span style={{cursor:'pointer',position: 'absolute',padding: '3px'}} class="material-icons"
                                              onClick={()=>{this.props.history.push('userInfo',{data:this.state.disqualifiedBy,actionType:'VIEW'}) }}>
                                                remove_red_eye
                                              </span>
                                              <span style={{cursor:'pointer',fontSize: '16px',fontWeight: '500',marginLeft: '2rem'}}
                                                onClick={()=>{this.props.history.push('userInfo',{data:this.state.disqualifiedBy}) }}>
                                                {allStrings.show}
                                              </span> 
                                            </p>
                                          </MDBCol>
                                      </MDBRow>
                                    }
                                    

                                    
                                    </div>
                                    <br></br>
                                    <br></br>
                                    <div className="text-center">
                                      {this.state.actionType==="EDIT"&&
                                        <MDBBtn
                                        style={{background:'#233b5b',color:'#fff'}}
                                        rounded
                                        color="#233b5b"
                                        type="submit"
                                        className="btn-block z-depth-1a"
                                        >
                                            <MDBIcon icon="edit" className="mr-2" />
                                            {allStrings.update}          
                                        </MDBBtn>
                                      }{/* }{this.state.actionType==="VIEW"&&this.state.actionType==="VIEW"&&
                                        <MDBBtn onClick={()=>{this.delete()}} rounded color="danger" className="btn-block z-depth-1a">
                                            <MDBIcon icon="trash-alt" className="mr-2" />
                                            {allStrings.remove}
                                        </MDBBtn>
                                      } */}
                                      {this.state.status ==="PENDING"&&this.state.actionType==="VIEW"&&
                                        <MDBBtn onClick={()=>{this.inContact()}} rounded color="green" className="btn-block z-depth-1a">
                                            <MDBIcon  className="mr-2" />
                                            {allStrings.inContact}
                                        </MDBBtn>
                                      }
                                      {this.state.status ==="PENDING"&&this.state.actionType==="VIEW"&&
                                        <MDBBtn onClick={()=>{this.toggle2();this.setState({closeType:'REJECTED'})}} rounded  className="btn-block z-depth-1a">
                                            <MDBIcon  className="mr-2" />
                                            {allStrings.rejected}
                                        </MDBBtn>
                                      }
                                      {this.state.status ==="IN-CONTACT"&&this.state.actionType==="VIEW"&&
                                        <MDBBtn onClick={()=>{this.toggle()}} rounded  className="btn-block z-depth-1a">
                                            <MDBIcon  className="mr-2" />
                                            {allStrings.saleDone}
                                        </MDBBtn>
                                      }
                                      {this.state.status ==="IN-CONTACT"&&this.state.actionType==="VIEW"&&
                                        <MDBBtn onClick={()=>{this.toggle2()}} rounded color="danger" className="btn-block z-depth-1a">
                                            <MDBIcon  className="mr-2" />
                                            {allStrings.disqualified}
                                        </MDBBtn>
                                      }
                                        
                                    </div>
                                </form>
                                </MDBCol>
                            </MDBRow>
                        </MDBContainer>
                        </CardContent>
                    </Card>
                </div>
            </MDBCol>
            </MDBRow>
            
      </MDBContainer>
      
    </div> 
  )
  }
}


const mapToStateProps = (state) => ({
    isRTL: state.lang.isRTL,
    currentUser: state.auth.currentUser,
  });
  
  const mapDispatchToProps = {
  };
  
  export default withRouter(
    connect(mapToStateProps, mapDispatchToProps)(clientInfo)
  );